import { render, staticRenderFns } from "./OperationHours.vue?vue&type=template&id=3be587c6"
import script from "./OperationHours.vue?vue&type=script&lang=js"
export * from "./OperationHours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports